module.exports = __webpack_public_path__ + "static/MANUAL.b3522d89.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/docs/MANUAL.pdf
// module id = 345
// module chunks = 35783957827783